export default function setImagePosition(imgWidth, imgHeight, file) {
    if (file) {
        const coords = file?.coords;

        const originalWidth = coords?.imageWidth;
        const originalHeight = coords?.imageHeight;
        const x = coords?.x ?? 0;
        const y = coords?.y ?? 0;

        let deltaX = Math.round((x * imgWidth) / originalWidth);
        let deltaY = Math.round((y * imgHeight) / originalHeight);
        deltaX = isNaN(deltaX) ? 0 : deltaX;
        deltaY = isNaN(deltaY) ? 0 : deltaY;

        return [deltaX, deltaY];
    }
}
